import { createMovieClip } from "../../../../common/functions/Functions_General";

class animationExpandingSymbol {
  private parent: PIXI.Container = new PIXI.Container();
  private animation: Array<PIXI.extras.AnimatedSprite>;
  constructor(parent: PIXI.Container, offsetY: number) {
    parent.addChild(this.parent);


    this.animation = [];
    for (let i = 0; i < 3; i++) {
      this.animation[i] = createMovieClip("expandBg", 0, 24);
      this.animation[i].blendMode = PIXI.BLEND_MODES.ADD;
      this.animation[i].loop = false;
      this.animation[i].anchor.set(0.5);
      this.animation[i].animationSpeed =.5;
      this.animation[i].gotoAndStop(0);
      this.animation[i].scale.set(2);
      this.animation[i].y = offsetY * i;
        this.parent.addChild( this.animation[i]);
      
    }


    this.clearAll();

  }
  public getParent = (): PIXI.Container => {
    return this.parent;
  };

  public clearAll = (): void => {
    for (let i = 0; i < this.animation.length; i++) {
      this.playSelected(false, i);
    }
  };
  public playSelected = (bool: boolean, index: number): void => {
    if (bool) {
      if (this.animation[index].playing == false) {
        this.animation[index].gotoAndPlay(0);
        this.animation[index].alpha = 1;
      }
    } else {
  
      this.animation[index].alpha = 0;
      this.animation[index].stop();
    }
  };
}

export class ExpandingSymbolHighlight {
  private parent: PIXI.Container = new PIXI.Container();
  private allReelsEffects: Array<animationExpandingSymbol>;

  constructor(
    parent: PIXI.Container,
    totalReels:number,
    initialPosition: Array<number>,
    offsetY: number,
    offsetX: number,
   
  ) {
    parent.addChild(this.parent);
    this.allReelsEffects = [];
    for (let i = 0; i < totalReels; i++) {
      this.allReelsEffects[i] = new animationExpandingSymbol(this.parent, offsetY);
      this.allReelsEffects[i].getParent().x = offsetX * i;
    }
    this.parent.position.set(initialPosition[0], initialPosition[1]);
  }

  public clearAll=():void=>
  {
    for (let index = 0; index < this.allReelsEffects.length; index++) {
        this.allReelsEffects[index].clearAll();
        
    }
  }
  public playSelected(posInArray:Array<number>)
  { 
        //--position x and Y array
    this.allReelsEffects[posInArray[0]].playSelected(true,posInArray[1]);
  }
}
